export const BLUE_TIK_ICON = '/assets/DashboardNewUser/blueTicks.png';
